cobalt-icon-button {
  display: flex;
}

cobalt-icon-button:not([size="small"]) {
  --number-radius-medium: var(--number-radius-round);
  --number-radius-large: var(--number-radius-round);
}

